import useStore from './_store'

export default ({className}) => {
	const jurisdictionName = useStore((state) => state.jurisdictionName)
	const totalRO = useStore((state) => state.totalRO)
	const unassignedRO = useStore((state) => state.unassignedRO)

	return <>
		<div className={`border-grey rounded-primary p-2 border-normal ${className}`}>
			<h3 className="font-bold">Current Selection</h3>

			<p>Jurisdiction - {jurisdictionName}</p>
			<p>Number of RO - {totalRO}</p>
			<p>Unassigned - {unassignedRO}</p>
		</div>
	</>
}